import type {
  ActivationDatafieldsToComplete,
  HelperResult,
  StudentApplication,
} from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const entityName = 'activationDatafieldsToComplete';

const { useGet: useGetActivationDatafieldsToComplete } = getCRUDHooks({
  entityName,

  get: ({
    userId,
    studentApplicationId,
  }: {
    userId: number;
    studentApplicationId: StudentApplication['id'];
  }): HelperResult<ActivationDatafieldsToComplete> =>
    clientApi
      .getOCClient()
      .createGetRequest<StudentApplication>('/users/:id/activation-datafields-to-complete')
      .setRouteParam('id', userId)
      .setQueryParam('studentApplicationId', studentApplicationId)
      .execute(),
});

// eslint-disable-next-line import/prefer-default-export
export { useGetActivationDatafieldsToComplete };
